











import ApiClient from '@/common/api'
import Menu from '@/views/template/Menu.vue'

export default
  name: 'Header'

  components: {
    Menu
  }

  props:
    title:
      type: String
      default: ''
    subTitle:
      type: String
      default: ''
    isPartner:
      type: Boolean
      default: false

  data: () ->
    level: 0

  created: () ->
    api = new ApiClient()
    data = await api.get('/fc/login/user_level')
    @level = Number(data.level)
    if !@isPartner
      if data.customer_id != '1'
        @$router.push '/'
